import React from 'react';
import ReactECharts from 'echarts-for-react';
import SafeIcon from '../common/SafeIcon';
import StatCard from '../components/dashboard/StatCard';

const Analytics = () => {
  const hiringTrendOption = {
    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: { type: 'category', data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'], axisLine: { show: false } },
    yAxis: { type: 'value', axisLine: { show: false }, splitLine: { lineStyle: { type: 'dashed' } } },
    series: [
      { name: 'Applications', type: 'bar', barWidth: '40%', data: [450, 620, 580, 890, 720, 950], itemStyle: { color: '#11469A', borderRadius: [4, 4, 0, 0] } },
      { name: 'Hires', type: 'bar', barWidth: '40%', data: [45, 52, 48, 70, 65, 82], itemStyle: { color: '#00AEEF', borderRadius: [4, 4, 0, 0] } }
    ]
  };

  const sourceOption = {
    tooltip: { trigger: 'item' },
    legend: { bottom: '0%', left: 'center', icon: 'circle' },
    series: [{
      name: 'Source',
      type: 'pie',
      radius: ['40%', '70%'],
      avoidLabelOverlap: false,
      itemStyle: { borderRadius: 10, borderColor: '#fff', borderWidth: 2 },
      label: { show: false },
      data: [
        { value: 1048, name: 'LinkedIn', itemStyle: { color: '#11469A' } },
        { value: 735, name: 'Company Website', itemStyle: { color: '#00AEEF' } },
        { value: 580, name: 'Referrals', itemStyle: { color: '#10b981' } },
        { value: 484, name: 'Indeed', itemStyle: { color: '#f59e0b' } }
      ]
    }]
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Recruitment Analytics</h1>
          <p className="text-gray-500">Comprehensive data on hiring performance and pipeline health.</p>
        </div>
        <button className="btn-primary flex items-center gap-2">
          <SafeIcon name="Download" size={18} /> Export Report
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard title="Time to Hire" value="18 Days" icon="Clock" trend="up" trendValue="2.4%" colorClass="bg-blue-50 text-brand-primary" />
        <StatCard title="Offer Acceptance" value="86%" icon="CheckCircle" trend="up" trendValue="5.1%" colorClass="bg-green-50 text-green-600" />
        <StatCard title="Cost per Hire" value="GH₵ 2,400" icon="DollarSign" trend="down" trendValue="1.2%" colorClass="bg-purple-50 text-purple-600" />
        <StatCard title="Sourcing Efficiency" value="92%" icon="Zap" trend="up" trendValue="8.4%" colorClass="bg-yellow-50 text-yellow-600" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 card p-6">
          <h3 className="text-lg font-bold text-gray-800 mb-6">Hiring Productivity Trends</h3>
          <div className="h-[350px]">
            <ReactECharts option={hiringTrendOption} style={{ height: '100%' }} />
          </div>
        </div>
        <div className="card p-6">
          <h3 className="text-lg font-bold text-gray-800 mb-6">Application Sources</h3>
          <div className="h-[350px]">
            <ReactECharts option={sourceOption} style={{ height: '100%' }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Analytics;